import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import {get} from 'lodash-es'


/**
 * 打卡配置列表
 */
 export const billSetInfoListPage = (current, pageSize, params) => {
    return request(`${UrlConfig.Kingdee.BillSetInfoList}?pageId=${current}&pageSize=${pageSize}`, {
      method: METHODS.POST,
      data: params,
    }).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
}
/**
 * 转换日志
 */
 export const dataConverLogPage = (current, pageSize, params) => {
    return request(`${UrlConfig.Kingdee.DataConverLog}/${current}/${pageSize}`, {
      method: METHODS.POST,
      data: params,
    }).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
}
/**
 * 转换日志
 */
 export const ruleConfigGetList = data => {
    return request(UrlConfig.Kingdee.RuleConfigGetList, {
        method: METHODS.POST,
        data,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 业务事项配置
 */
 export const businessMattersSearch = (current, pageSize, params) => {
  return request(`${UrlConfig.Kingdee.BusinessMattersSearch}/${current}/${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const billSetInfoSearchList = data => {
  return request(UrlConfig.Kingdee.BillSetInfoSearchList, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const updateMapping = data => {
  return request(UrlConfig.Kingdee.UpdateMapping, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const businessMattersFieldMappingList = data => {
  return request(UrlConfig.Kingdee.BusinessMattersFieldMappingList, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const commonConvertGetJsonAllPath = data => {
  return request(UrlConfig.Kingdee.CommonConvertGetJsonAllPath, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const addBusMattersOfBill = data => {
  return request(data.id ? UrlConfig.Kingdee.UpdateByIdBusMattersOfBill : UrlConfig.Kingdee.BusMattersOfBill, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const addBusinessMattersDetails = data => {
  return request(UrlConfig.Kingdee.BusinessMattersDetails, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const queryOrgDataByBillId = data => {
  return request(UrlConfig.Kingdee.QueryOrgDataByBillId, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const busMattersOfBillList = data => {
  return request(UrlConfig.Kingdee.BusMattersOfBillList, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
// 业务事项与账套关联 防止冲突重新命名
export const getBusMattersOfBillPageList = data => {
  return request(UrlConfig.Kingdee.BusMattersOfBillList, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const copyAddBusinessMatters = data => {
  return request(UrlConfig.Kingdee.CopyAddBusinessMatters, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const deleteBillAndMappingDataById = id => {
  return request(`${UrlConfig.Kingdee.DeleteBillAndMappingDataById}/${id}`, {
    method: METHODS.DELETE,
  })
}
export const checkBusinessMatters = id => {
  return request(`${UrlConfig.Kingdee.CheckBusinessMatters}/${id}`, {
    method: METHODS.GET,
  })
}
// 表达式管理库 

export const deleteCalculationFormula = id => {
  return request(`${UrlConfig.Kingdee.DeleteCalculationFormula}/${id}`, {
    method: METHODS.DELETE,
  })
}
export const checkCalculationFormula = data => {
  return request(UrlConfig.Kingdee.CheckCalculationFormula, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const getExpressVariables = data => {
  return request(UrlConfig.Kingdee.GetExpressVariables, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const runExpressVariables = data => {
  return request(UrlConfig.Kingdee.RunExpressVariables, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const saveCalculationFormula = data => {
  return request(UrlConfig.Kingdee.SaveCalculationFormula, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const calculationFormulaList = (current, pageSize, params) => {
  return request(`${UrlConfig.Kingdee.CalculationFormulaList}/${current}/${pageSize}`, {
      method: METHODS.POST,
      data:params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const ruleConfigSearchList = (current, pageSize, params) => {
  return request(`${UrlConfig.Kingdee.RuleConfigSearch}/${current}/${pageSize}`, {
      method: METHODS.POST,
      data:params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const calculationFormulaSearch = (current, pageSize, params) => {
  return request(`${UrlConfig.Kingdee.CalculationFormulaSearch}/${current}/${pageSize}`, {
      method: METHODS.POST,
      data:params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
// 业务事项
export const businessMattersDetails = id => {
  return request(`${UrlConfig.Kingdee.GetBusinessMattersDetails}/${id}`, {
    method: METHODS.GET,
  })
}
export const ruleConfigDetails = id => {
  return request(`${UrlConfig.Kingdee.RuleConfigDetails}/${id}`, {
    method: METHODS.GET,
  })
}
export const ruleConfigDtlDetails = id => {
  return request(`${UrlConfig.Kingdee.RuleConfigDtlDetails}/${id}`, {
    method: METHODS.GET,
  })
}
export const ruleConfigDtlQuoteCheckData = id => {
  return request(`${UrlConfig.Kingdee.RuleConfigDtlQuoteCheckData}/${id}`, {
    method: METHODS.GET,
  })
}
export const ruleConfigDtlCheckData = id => {
  return request(`${UrlConfig.Kingdee.RuleConfigDtlCheckData}/${id}`, {
    method: METHODS.GET,
  })
}
export const ruleConfigSave = data => {
  return request(UrlConfig.Kingdee.RuleConfigSave, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const ruleConfigDtlSave = data => {
  return request(UrlConfig.Kingdee.RuleConfigDtlSave, {
      method: METHODS.POST,
      data,
  }).then((resp: any) => {
      return resp
  })
}
export const ruleConfigDtlDelete = id => {
  return request(`${UrlConfig.Kingdee.RuleConfigDtlDelete}/${id}`, {
    method: METHODS.DELETE,
  })
}
export const ruleConfigDtlAttrConverDelete = id => {
  return request(`${UrlConfig.Kingdee.RuleConfigDtlAttrConverDelete}/${id}`, {
    method: METHODS.DELETE,
  })
}
export const ruleConfigDtlAttrConverBatDel = (data) => {
  return request(`${UrlConfig.Kingdee.RuleConfigDtlAttrConverBatDel}`, {
    method: METHODS.POST,
    data,
  })
}
//企业认证
export const esignCommonFindCompanyConfig = (current, pageSize, params) => {
  return request(`${UrlConfig.Esign.EsignCommonFindCompanyConfig}?crrunt=${current}&size=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const esignCommonApply = id => {
  return request(`${UrlConfig.Esign.EsignCommonApply}/${id}`, {
    method: METHODS.POST,
  })
}
export const esignCommonDealetCompny = id => {
  return request(`${UrlConfig.Esign.EsignCommonDealetCompny}/${id}`, {
    method: METHODS.DELETE,
  })
}
export const esignCommonSaveOrUpdateCompny = (data) => {
  return request(`${UrlConfig.Esign.EsignCommonSaveOrUpdateCompny}`, {
    method: METHODS.POST,
    data,
  })
}
export const esignCommonUpdateById = (data) => {
  return request(`${UrlConfig.Esign.EsignCommonUpdateById}`, {
    method: METHODS.POST,
    data,
  })
}
export const queryKdCompanyInfo = (data) => {
  return request(`${UrlConfig.Kingdee.QueryKdCompanyInfo}`, {
    method: METHODS.POST,
    data,
  })
}
//启用停用
export const receiptRuleState = data => {
  return request(UrlConfig.Fms.ReceiptRuleState, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}